import { useState, useCallback } from 'react';
import { useAppDispatch } from 'shared/hooks';
import { saveLead } from 'shared/thunks/saveLead';
import { ModalForm } from 'shared/components/ModalForm';

export const ModalFormContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [isAgreed, setIsAgreed] = useState(false);
  const [errors, setErrors] = useState<{ name?: string; phone?: string; email?: string; agreement?: string }>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isLoading = isSubmitting;

  const validateForm = useCallback((): boolean => {
    const newErrors: { name?: string; phone?: string; email?: string; agreement?: string } = {};

    if (!name.trim()) {
      newErrors.name = 'Поле обязательно для заполнения';
    }

    if (!phone.trim()) {
      newErrors.phone = 'Поле обязательно для заполнения';
    }

    if (!email.trim()) {
      newErrors.email = 'Поле обязательно для заполнения';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        newErrors.email = 'Введите email в формате example@mail.ru';
      }
    }

    if (!isAgreed) {
      newErrors.agreement = 'Необходимо согласие на обработку персональных данных';
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  }, [name, phone, email, isAgreed]);

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();

      if (!validateForm()) {
        return;
      }

      setIsSubmitting(true);
      dispatch(
        saveLead({
          name: name.trim(),
          phone: phone.trim(),
          email: email.trim(),
        }),
      ).finally(() => {
        setIsSubmitting(false);
      });
    },
    [dispatch, name, phone, email, validateForm],
  );

  return (
    <ModalForm
      name={name}
      phone={phone}
      email={email}
      isAgreed={isAgreed}
      errors={errors}
      isLoading={isLoading}
      onNameChange={setName}
      onPhoneChange={setPhone}
      onEmailChange={setEmail}
      onAgreementChange={setIsAgreed}
      onSubmit={handleSubmit}
    />
  );
};
